<template>
  <div class="content">
    <div class="content-wrap">
      <h3>{{ t('add-user').toUpperCase() }}</h3>
      <div class="card-body">
        <!-- VeeValidate formularz z walidacją -->
        <Form
          ref="form"
          @submit="onSubmit"
          :validation-schema="schema"
          v-slot="{ errors, isSubmitting }"
          :keepValues="false"
        >
          <!-- Główna sekcja formularza, 2 kolumny -->
          <div class="column d-flex justify-content-center user-data">
            <!-- Kolumna 1 -->
            <div class="col-sm-6">
              <!-- Login użytkownika -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('username') }}:</label>
                <div class="col-sm-8">
                  <Field name="userName" type="text" class="form-control" :class="{ 'is-invalid': errors.userName }" />
                  <div class="invalid-feedback">{{ errors.userName }}</div>
                </div>
              </div>
              <!-- Hasło użytkownika -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('password') }}:</label>
                <div class="col-sm-8">
                  <Field name="password" type="password" class="form-control" v-model="form.password" :class="{ 'is-invalid': errors.password }" />
                  <div class="invalid-feedback">{{ errors.password }}</div>
                </div>
              </div>
              <!-- Powtórz hasło -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('confirm-password') }}:</label>
                <div class="col-sm-8">
                  <Field name="password2" type="password" class="form-control" v-model="form.password2" :class="{ 'is-invalid': errors.password2 }" />
                  <div class="invalid-feedback">{{ errors.password2 }}</div>
                </div>
              </div>
              <!-- Wizualizacja siły hasła -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Poziom siły hasła:</label>
                <div class="col-sm-8">
                  <password-meter :password="form.password" />
                  <div class="d-flex password-meter justify-content-center center-aligned">
                    <div class="col-sm-4">Słabe</div>
                    <div class="col-sm-4">Średnie</div>
                    <div class="col-sm-4">Silne</div>
                  </div>
                </div>
              </div>
              <!-- Telefon użytkownika -->
              <div class="form-group row phone">
                <label class="col-sm-4 col-form-label">{{ t('phone-number') }}:</label>
                <div class="col-sm-8 d-flex flex-row">
                  <!-- Prefiks +48 (zablokowany) -->
                  <input type="text" class="form-control" value="+48" disabled style="width: 50px; text-align: center; margin-right: 5px;" />
                  <!-- Numer telefonu -->
                  <Field name="phoneNumber" type="text" class="form-control phone-number" :class="{ 'is-invalid': errors.phoneNumber }" />
                </div>
                <div class="invalid-feedback phone-invalid">{{ errors.phoneNumber }}</div>
              </div>
            </div>
            <!-- Kolumna 2 -->
            <div class="col-sm-6">
              <!-- Uprawnienia -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('permissions') }}:</label>
                <div class="col-sm-8">
                  <Field name="roles" as="select" class="form-control" :class="{ 'is-invalid': errors.roles }">
                    <option value="" disabled>Wybierz rolę</option>
                    <option v-for="role in rolesAvailable" :key="role.id" :value="role.id">
                      {{ role.name }}
                    </option>
                  </Field>
                  <div class="invalid-feedback">{{ errors.roles }}</div>
                </div>
              </div>
              <!-- Imię -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('name') }}:</label>
                <div class="col-sm-8">
                  <Field name="firstName" type="text" class="form-control" :class="{ 'is-invalid': errors.firstName }" />
                  <div class="invalid-feedback">{{ errors.firstName }}</div>
                </div>
              </div>
              <!-- Nazwisko -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('lastname') }}:</label>
                <div class="col-sm-8">
                  <Field name="lastName" type="text" class="form-control" :class="{ 'is-invalid': errors.lastName }" />
                  <div class="invalid-feedback">{{ errors.lastName }}</div>
                </div>
              </div>
              <!-- E-mail -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('email-address') }}:</label>
                <div class="col-sm-8">
                  <Field name="email" type="text" class="form-control" :class="{ 'is-invalid': errors.email }" />
                  <div class="invalid-feedback">{{ errors.email }}</div>
                </div>
              </div>
              <!-- Opis użytkownika -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('description') }}:</label>
                <div class="col-sm-8">
                  <Field name="description" type="textarea" class="form-control" />
                  <div class="invalid-feedback">{{ errors.description }}</div>
                </div>
              </div>
              <!-- Status użytkownika (checkbox) -->
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('status') }}:</label>
                <div class="col-sm-8">
                  <Field name="status" type="checkbox" :value="true" />
                  <div class="invalid-feedback">{{ errors.status }}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- Propozycja hasła + generowanie -->
          <div class="column d-flex justify-content-center">
            <div class="form-group col">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">{{ t('password-proposal') }}:</label>
                <div class="col-sm-8">
                  <Field name="proposed" type="text" class="form-control" v-model="form.proposed" />
                </div>
              </div>
            </div>
            <div class="col generate-pass">
              <div class="row">
                <div class="col-sm-4">
                  <button type="button" @click="generatePassword" class="btn button-add-user generate">
                    {{ t('generate').toUpperCase() }}
                  </button>
                </div>
                <div class="col-sm-8">
                  <button type="button" @click="usePassword" class="btn button-add-user use-password" :disabled="!form.proposed">
                    {{ t('use-suggested-password') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Obsługa komunikatów o błędach i sukcesach -->
          <div class="form-group row d-flex flex-column align-items-center process">
            <div class="col-auto" v-if="processError">
              <div class="process-error form-control">{{ processError }}</div>
            </div>
            <div class="col-auto" v-if="processSuccess">
              <div class="process-success form-control">{{ processSuccess }}</div>
            </div>
            <div class="col-auto">
              <button type="button" @click="goBack" class="btn button-add-user">
                {{ t('cancel') }}
              </button>
              <button class="btn button-save" :disabled="isSubmitting">
                <span v-show="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
                {{ t('save').toUpperCase() }}
              </button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script setup>
import moment from "moment";
import {Field, Form} from "vee-validate";
import * as Yup from "yup";

moment.locale("pl");

// Import tłumaczeń
const { t } = useI18n();

// Definicja reguł walidacji formularza (VeeValidate/Yup)
const schema = Yup.object().shape({
  userName: Yup.string().required(t('user-username-required')),
  password: Yup.string().required(t('user-password-required')),
  password2: Yup.string().required(t('user-password-required')),
  phoneNumber: Yup.string().required(t('user-phone-required')),
  firstName: Yup.string().required(t('user-name-required')),
  lastName: Yup.string().required(t('user-lastname-required')),
  email: Yup.string()
    .required(t('user-email-required'))
    .email(t('incorrect-email-address')),
  roles: Yup.string().required(t('user-permissions-required')),
  description: Yup.string(),
  status: Yup.bool(),
  ticket: Yup.bool(),
});
</script>

<script>
import PasswordMeter from "vue-simple-password-meter";
import Users from "@/services/Users";
import { useI18n } from 'vue-i18n';

export default {
  components: {
    PasswordMeter,
  },
  name: "AddUser",
  data() {
    return {
      // Stany i dane formularza
      loading: false,
      users: [],
      rolesAvailable: [],
      error: null,
      moment: moment,
      getPasswordLength: 14,
      processError: false,
      processSuccess: false,
      form: {
        userName: "",
        password: "",
        password2: "",
        phoneNumber: "",
        proposed: "",
        firstName: "",
        lastName: "",
        email: "",
        roles: "",
        description: "",
        status: false,
        ticket: false,
        organizationName: "",
      },
      organizationsAvailable: [],
    };
  },
  created() {
    this.fetchRoles(); // Pobierz dostępne role
  },
  methods: {
    // Powrót do poprzedniego widoku
    goBack() {
      this.$emit("cancel-add-user");
    },
    // Pobierz listę ról użytkowników z API
    fetchRoles() {
      Users.getRolesList()
        .then((roles) => {
          this.rolesAvailable = roles;
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        });
    },
    // Generuj losowe hasło
    generatePassword() {
      const digits = "1234567890";
      const alphabet = "1234567890-=!@#$%^&*()_+qazwsxedcrfvtgbyhnujmik,ol.p;/[]QAZWSXEDCRFVTGBYHNUJMIKOL>P:?{'}|";
      
      let pass = "";
      pass += digits[Math.floor(Math.random() * digits.length)];
      for (let i = 1; i < this.getPasswordLength; i++) {
        pass += alphabet[Math.floor(Math.random() * alphabet.length)];
      }
      pass = pass.split("").sort(() => 0.5 - Math.random()).join("");
      this.form.proposed = pass;
      return pass;
    },
    // Użyj wygenerowanego hasła w polach formularza
    usePassword() {
      this.form.password = this.form.proposed;
      this.form.password2 = this.form.proposed;
    },
    // Resetuj stan formularza (po sukcesie)
    resetForm() {
      this.form = {
        userName: "",
        password: "",
        password2: "",
        phoneNumber: "",
        proposed: "",
        firstName: "",
        lastName: "",
        email: "",
        roles: "",
        description: "",
        status: false,
        ticket: false,
      };
      if (this.$refs.form) {
        this.$refs.form.resetForm();
      }
    },
    // Obsługa submit formularza
    onSubmit(values) {
      this.processSuccess = null;
      this.processError = null;

      const roleId = Number(values.roles);
      const selectedRole = this.rolesAvailable.find(r => Number(r.id) === roleId);

      if (!selectedRole) {
        this.processError = "Nie znaleziono roli (sprawdź typy id).";
        return;
      }

      // Walidacja admina (rola 8) — poprawiona, bez JSON.stringify
      if ((roleId === 8 || roleId === 13) && values.password.length < 12) {
        this.processError = this.$t('password-for-admin-cannot-be-shorter-than-12');
        return;
      }

      const sendUser = {
        username: values.userName,
        password: values.password,
        firstName: values.firstName,
        lastName: values.lastName,
        phoneNumber: `+48${values.phoneNumber}`,
        roles: [roleId],
        enabled: !!values.status,
        ticket: !!values.ticket,
        email: values.email,
        description: values.description,
        sendUserLogsToServer: true,
      };

      Users.addUser(sendUser)
          .then(() => {
            this.processSuccess = "Dodano użytkownika";
            this.$refs.form?.resetForm();
            this.$emit('user-added');
            this.$router.push('/user-management');
          })
          .catch((error) => {
            console.log(error);
            this.processError = error;
          });
    },
  },
  // Setup do wsparcia dla password meter
  setup() {
    const password = this.form.password;
    return {
      password,
    };
  },
};
</script>

<style scoped>

.col-form-label {
  text-align: right;
}
.process-error {
  color: darkred;
}

.process-success {
  color: #42b983;
}

.content {
  width: 100%;
  min-height: 270px;
  margin-bottom: 20px;
}

.password-meter {
  font-size: 12px;
}

h3 { 
  padding: 15px 25px;
  background-color: white;
}

.card-body .column {
  padding: 20px 30px;
}

.card-body .column > div {
  padding: 5px 20px;
}

.user-data {
  border-bottom: 1px solid #b8b8b6;
}

.invalid-feedback {
  font-size: 11px;
}

input[type="checkbox"] {
  margin-top: 13px;
}

.generate-pass {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.button-add-user {
  margin-bottom: 1rem;
  padding: 0.5rem 2rem 0.5rem 2rem;
  margin-right: 0.5rem;
}

.button-save {
  margin-bottom: 1rem;
  padding: 0.5rem 2rem 0.5rem 2rem;
  border: 1px solid #007e1a;
}

.generate {
  padding: .75rem 2rem .75rem 2rem;
}

.use-password {
  padding: .75rem 2rem .75rem 2rem;
}

.phone {
  margin-top: 1.7rem;
}

.process-success {
  margin-bottom: 1rem;
}

.process-error {
  margin-bottom: 1rem;
}

.phone-invalid {
  text-align: end;
}

</style>
